import script from "./BoothCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoothCount.vue?vue&type=script&setup=true&lang=ts"

import "./BoothCount.vue?vue&type=style&index=0&id=3a500df2&lang=scss&scoped=true"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a500df2"]])

export default __exports__